import { useStoreAuth } from "../store";
import axios from "axios";

export default function useAuth() {
  const context = useStoreAuth();
  const sessionContext = context?.client?.useSession();

  const { error: sessionError, isPending, isRefetching, refetch } = sessionContext || {};
  const { user, session } = sessionContext?.data || {};

  const login = async (email, password, captcha) => {
    const { data, error } = await context.client.signIn.email({ email, password, 
      fetchOptions: { 
        headers: { 
            "x-captcha-response": captcha || "",
        }, 
      } 
    });
    if (error) throw error;

    return data;
  };

  const register = async ({ email, password, name, image, captcha, callbackURL }) => {
    const payload = { email, password, name, isPublic: true, fetchOptions: {
        headers: {
            "x-captcha-response": captcha || "",
        },
      }
    };
    if (typeof image === "string" && image.trim() !== "") payload.image = image;
    if (callbackURL) payload.callbackURL = callbackURL;

    const { data, error } = await context.client.signUp.email(payload);
    if (error) throw error;

    return data;
  };

  const logout = async () => {
    await context.client.signOut({
      fetchOptions: {
        onSuccess: () => {
          localStorage.removeItem('pn');
          window.location.href = "/auth"
        }
      },
    });
  };

  const resendVerificationEmail = async () => {
    console.log("Resending verification email to:", user);
    if(!user || user.emailVerified) throw new Error("User email is already verified or user not logged in.");
    await context.client.sendVerificationEmail({
      email: user.email,
      callbackURL: window.location.origin + '/auth/email/verify' + window.location.search,
    });
  };

  const idpLogin = async (provider) => {
    const { data, error } = await context.client.signIn.social({ 
      provider,
      callbackURL: window.location.origin + "/auth",
    });
    if (error) throw error;
    return data;
  }

  const randomMessage = async () => {
    const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/auth/v1/random-message`);

    return data;
  }

  const acceptInvitation = async (token) => {
    if (!context?.client?.organization?.acceptInvitation) {
      throw new Error("acceptInvitation is not available");
    }

    const payload = {
      invitationId: token,
      invitationToken: token,
    };
    console.log('acceptInvitation payload:', payload);
    const { data, error } = await context.client.organization.acceptInvitation(payload);
    if (error) throw error;
    return data;
  };

  const tokenExpiration = () => {
    try {
      const payload = context.token.split(".")[1];
      const json = JSON.parse(atob(payload));
      return typeof json?.exp === "number" ? json.exp * 1000 : null;
    } catch {
      return null;
    }
  };

  return {
    ...context,
    login,
    register,
    logout,
    resendVerificationEmail,
    idpLogin,
    randomMessage,
    acceptInvitation,
    tokenExpiration,
    error: sessionError,
    isPending,
    isRefetching,
    refetch,
    user,
    session,
    isManager: false
  };
}
